// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7f744eab3351023d076f","351":"f831bfa478e5f0e55bf1","691":"04dd9b85e34cf49b3834"}[chunkId] + ".js";
};